import React from 'react'

export const Error404 = () => {
  return (
    <div>
      <h1>Error 404</h1>
      <h3>Not found</h3>
    </div>
  )
}
